import React from 'react';
import {
  FormTab,
  TextField,
  ReferenceField,
  BooleanField,
  ReferenceManyField,
  Datagrid,
  DeleteButton,
  EditButton,
} from 'react-admin';
import CreateRelatedButton from '../components/CreateRelatedButton';
import { isProductiveRule } from './regla-utils';

const ReglaEtiquetasTab = ({ ...props }) => {
  const _isProductiveRule = isProductiveRule(props);
  return (
    <FormTab label="resources.regla.tabs.etiquetas" path="etiquetas" {...props}>
      {!_isProductiveRule && (
        <CreateRelatedButton
          reference="regla-etiqueta"
          refFieldName="idRegla"
          label="resources.regla.buttons.asociarEtiqueta"
        />
      )}
      <ReferenceManyField
        addLabel={false}
        reference="regla-etiqueta"
        target="idRegla"
        filter={{ deleted: false }}
      >
        <Datagrid>
          <TextField
            source="idEtiqueta"
            label="resources.regla-etiqueta.fields.idEtiqueta"
          />
          <ReferenceField
            label="resources.etiqueta.fields.descripcion"
            source="idEtiqueta"
            reference="etiquetas"
            link={false}
          >
            <TextField source="descripcion" />
          </ReferenceField>
          <BooleanField
            source="excluye"
            label="resources.regla-etiqueta.fields.excluye"
          />
          {!_isProductiveRule && (
            <DeleteButton mutationMode="optimistic" redirect={false} />
          )}
          {!_isProductiveRule && <EditButton />}
        </Datagrid>
      </ReferenceManyField>
    </FormTab>
  );
};

export default ReglaEtiquetasTab;
